module.exports = __webpack_public_path__ + "static/for-businesses@3x-8624f783ba901d8f2a3ed120e14ba1e4.jpg";